import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import PensionShortfallCalculator from "../../calculators/PensionsShortfallCalculator";

const PensionShortfallPage = () => {
  return (
    <div>
      <Hero
        title="Pension Shortfall"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <PensionShortfallCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default PensionShortfallPage;
